/**
 * Human-readable message of a failed API call: the backend's `message`
 * (class-validator sends an array — joined), otherwise `fallback`.
 */
export const extractErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  const message = (error as { response?: { data?: { message?: unknown } } })
    ?.response?.data?.message;
  if (Array.isArray(message)) return message.join(", ") || fallback;
  return typeof message === "string" && message ? message : fallback;
};
